// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function mapLocalStringToTypeLocale(val) {
  var match = val.toLowerCase();
  var exactMatch;
  switch (match) {
    case "ar" :
        exactMatch = "AR";
        break;
    case "ca" :
        exactMatch = "CA";
        break;
    case "de" :
        exactMatch = "DE";
        break;
    case "en" :
        exactMatch = "EN";
        break;
    case "en-gb" :
        exactMatch = "EN_GB";
        break;
    case "es" :
        exactMatch = "ES";
        break;
    case "fr" :
        exactMatch = "FR";
        break;
    case "fr-be" :
        exactMatch = "FR_BE";
        break;
    case "he" :
        exactMatch = "HE";
        break;
    case "it" :
        exactMatch = "IT";
        break;
    case "ja" :
        exactMatch = "JA";
        break;
    case "nl" :
        exactMatch = "NL";
        break;
    case "pl" :
        exactMatch = "PL";
        break;
    case "pt" :
        exactMatch = "PT";
        break;
    case "ru" :
        exactMatch = "RU";
        break;
    case "sv" :
        exactMatch = "SV";
        break;
    case "zh" :
        exactMatch = "ZH";
        break;
    case "zh-hant" :
        exactMatch = "ZH_HANT";
        break;
    default:
      exactMatch = undefined;
  }
  if (exactMatch !== undefined) {
    return exactMatch;
  }
  var baseLanguage = Core__Option.getOr(val.toLowerCase().split("-")[0], "");
  switch (baseLanguage) {
    case "ar" :
        return "AR";
    case "ca" :
        return "CA";
    case "de" :
        return "DE";
    case "es" :
        return "ES";
    case "fr" :
        return "FR";
    case "he" :
        return "HE";
    case "it" :
        return "IT";
    case "ja" :
        return "JA";
    case "nl" :
        return "NL";
    case "pl" :
        return "PL";
    case "pt" :
        return "PT";
    case "ru" :
        return "RU";
    case "sv" :
        return "SV";
    case "zh" :
        return "ZH";
    default:
      return "EN";
  }
}

export {
  mapLocalStringToTypeLocale ,
}
/* No side effect */
